var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01BF9B",
    fillRule: "nonzero",
    d: "M0 8.727V12h3.273A3.268 3.268 0 0 0 0 8.727zm0-4.363v2.181A5.457 5.457 0 0 1 5.455 12h2.181A7.63 7.63 0 0 0 0 4.364zM0 0v2.182c5.422 0 9.818 4.396 9.818 9.818H12C12 5.367 6.622 0 0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.047e74d38a8220b142ed99b8c07530c9.svg";
export { ForwardRef as ReactComponent };